import React, { useEffect, useState, useRef } from "react";
import MobHeader from "../../Components/Header/MobHeader";
import { Col, Divider, Row, Space } from "antd";
import {
  ThemeDivider,
  ThemeFilterBtn,
  ThemeInput,
  ThemeMainWrapper,
} from "../Styles/Theme";
import {
  ProjectActiveTag,
  ProjectGptChatMassage,
} from "./ProjectsStyle";
import { useNavigate } from "react-router-dom";
const Gpt = ({ placeholder = "Type Message" }) => {
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);

  useEffect(() => {
    document.body.classList.add("bodyChatGPT");
    return () => {
      document.body.classList.remove("bodyChatGPT");
    };
  }, []);

  //   const [isMobile, setIsMobile] = useState(false);
  //   useEffect(() => {
  //     const checkIsMobile = () => {
  //       setIsMobile(window.innerWidth < 768);
  //     };
  //     checkIsMobile();
  //     window.addEventListener("resize", checkIsMobile);
  //     return () => {
  //       window.removeEventListener("resize", checkIsMobile);
  //     };
  //   }, []);

  const [messages, setMessages] = useState([
    {
      id: 1,
      text: (
        <>
          What conversations are young men having that politicians <br /> seem
          unwilling to engage in
        </>
      ),
      sender: "user",
    },
    {
      id: 2,
      text: (
        <>
          <h6>
            Exploring Conversations Young Men Are Having That Politicians Seem
            Unwilling to Engage In 🚀
          </h6>
          <p>
            Across the landscape of young American men, there's a rich tapestry
            of conversations that often go unaddressed by the political class.
            These discussions revolve around economic uncertainty, disconnection
            from traditional political messaging, and struggles with identity
            and masculinity. Let’s dive deeper into these themes:
          </p>
          <Divider />
          <h6>
            Economic Concerns and Disillusionment with Political Messaging 💼
          </h6>
          <p>
            Many young men express frustration over the economy's trajectory and
            their place within it. The anxiety stems from perceived unfulfilled
            promises from politicians and a lack of focus on improving workers'
            rights.
          </p>
          <ul>
            <li>
              <span>Matthew, a resident from a small town, reflected:</span> “I
              think initially, it was he [Trump] seemed to express an interest
              in focusing on issues here in America and correcting some of the
              problems we have so we can improve our own qualities of
              life.” Yet, he also notes the outcome wasn’t as expected.
            </li>
            <li>
              The sentiment is further shared by{" "}
              <span>Nicholas from the Northeast,</span>
              who discussed the perceived lack of attention from politicians on
              systemic support for young men: “I feel like there’s no
              consistency across the board for your standard young man... there
              doesn't seem like there's many options out there.”.
            </li>
          </ul>
          <ThemeDivider />
          <h6>
            Identity, Masculinity, and Misplaced Hope in Strong Leadership 👔
          </h6>
          <p>
            A recurring theme is the identification with strong, unapologetic
            figures that some young men feel are missing from current political
            discourse. This identification is often wrapped in a yearning for a
            simpler past or more traditional roles.
          </p>
          <ul>
            <li>
              <span>
                Jeremy, from a community college, remarked on Trump's appeal:
              </span>{" "}
              “He says what he wants, does what he wants. That’s like the
              mentality of a younger man... you’re not gonna stop me. I’m gonna
              do what I want.” This speaks to a narrative of empowerment and
              agency that resonates with some.
            </li>
            <li>
              Some young men also compare current political narratives to
              nostalgia or traditional societal roles, with{" "}
              <span>Gerardo from the Southwest Hispanic community noting:</span>{" "}
              “It all goes back to keeping things how they were when our parents
              were growing up... one of the biggest issues is breaking
              tradition.”.
            </li>
          </ul>
        </>
      ),
      sender: "assistant",
    },
    {
      id: 3,
      text: (
        <>
          <h6>What would you like to create?</h6>
          <Space gap={10} className="mt-2" wrap={true}>
            <ThemeFilterBtn
              // onClick={() => navigate("/polling-agents/polling-agent/")}
              shape="square"
              className="noBackground smallFont"
            >
              Run Poll
            </ThemeFilterBtn>
            <ThemeFilterBtn
              onClick={() => navigate("/surveys/study")}
              shape="square"
              className="noBackground smallFont"
            >
              Create Survey
            </ThemeFilterBtn>
            <ThemeFilterBtn shape="square" className="noBackground smallFont">
              Generate PDF Report
            </ThemeFilterBtn>
          </Space>
        </>
      ),
      sender: "assistant",
    },
  ]);

  const [newMessage, setNewMessage] = useState("");

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSend = () => {
    if (newMessage.trim()) {
      const message = {
        id: messages.length + 1,
        text: newMessage,
        sender: "user",
        timestamp: new Date().toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };
      setMessages([...messages, message]);
      setNewMessage("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <>
      <MobHeader />
      <ThemeMainWrapper
        className="hasHeader smallPadding"
        title={
          <Space gap={10}>
            <ThemeFilterBtn
              className="shadow"
              onClick={() => navigate(-1)}
              size="middle"
              icon={<img src="/images/back-icon.svg" alt="Back" />}
            />
            SAM Project
          </Space>
        }
        extra={
          <Space>
            <ProjectActiveTag>
              <Space align="center">
                <img src="/images/active-tag-icon.svg" />
                Active
              </Space>
            </ProjectActiveTag>
            <ThemeFilterBtn
              size="large"
              shape="square"
              icon={<img src="/images/history-icon.svg" alt="History" />}
            >
              History
            </ThemeFilterBtn>
          </Space>
        }
        actions={[
          <Row gutter={[16, 16]}>
            <Col
              xs={{ span: 24, offset: 0 }}
              sm={{ span: 24, offset: 0 }}
              md={{ span: 18, offset: 3 }}
              lg={{ span: 16, offset: 4 }}
              xl={{ span: 16, offset: 4 }}
              xxl={{ span: 16, offset: 4 }}
            >
              <ThemeInput
                className="placeholderItalic placeholderItalic rounded shadow"
                size="large"
                placeholder="Ask a question to generate insights from your data..."
                suffix={
                  <>
                    <ThemeFilterBtn
                      className="noStyle bgTransparent"
                      type="text"
                      size="small"
                      icon={<img src="/images/voice-icon.svg" />}
                    />
                    <ThemeFilterBtn
                      className="background"
                      //   onClick={() => navigate("/projects/gpt-chat")}
                      onClick={handleSend}
                      size="middle"
                      shape="circle"
                      icon={<img src="/images/send-icon.svg" alt="Send" />}
                    />
                  </>
                }
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <div className="presEnterLine">
                Press Enter to send • Shift+Enter for a new line
              </div>
            </Col>
          </Row>,
        ]}
      >
          <Row gutter={[16, 16]}>
            <Col
              xs={{ span: 24, offset: 0 }}
              sm={{ span: 24, offset: 0 }}
              md={{ span: 18, offset: 3 }}
              lg={{ span: 16, offset: 4 }}
              xl={{ span: 16, offset: 4 }}
              xxl={{ span: 16, offset: 4 }}
            >
              <div className="scrollable">
                <ProjectGptChatMassage>
                  {messages.map((message) => (
                    <div
                      className="messageContainer"
                      key={message.id}
                      isUser={message.sender === "user" ? "true" : "false"}
                    >
                      <div>
                        <div className="messageText">{message.text}</div>
                      </div>
                    </div>
                  ))}
                  <div ref={messagesEndRef} />
                </ProjectGptChatMassage>
              </div>
            </Col>
          </Row>
      </ThemeMainWrapper>
    </>
  );
};

export default Gpt;
